import axios from "axios";

const COUNTRIES_LOADING = "COUNTRIES_LOADING";
const COUNTRIES_FETCHED = "COUNTRIES_FETCHED";

export const actionCreators = {
    fetchCountries: () => async (dispatch, getState) => {
        try{
            if(getState().countries.isLoading){
                return;
            }
            dispatch({type:COUNTRIES_LOADING,isLoading:true});
            let url = "/api/country";
            let response = await axios.get(url);
            dispatch({type:COUNTRIES_FETCHED,countries:response.data});
            dispatch({type:COUNTRIES_LOADING,isLoading:false});
        }
        catch (e){
            dispatch({type:COUNTRIES_LOADING,isLoading:false});
            throw e;
        }
    }
};

const initialState = {
    isLoading:false,
    list:[]
};

export const reducer = (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case COUNTRIES_LOADING:
            return {...state,isLoading:action.isLoading};
        case COUNTRIES_FETCHED:
            return {...state,list:action.countries};
        default:
            return state;
    }
};